module.exports = {
  siteMetadata: {
    title: 'Jimmy Cleveland - Developer Portfolio',
    author: 'Jimmy Cleveland',
    description:
      'A developer portfolio based on the Ceevee Gatsby starter by Styleshout',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: `gatsby-plugin-typography`,
      options: {
        pathToConfigModule: `src/utils/typography.js`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/assets/images`,
      },
    },
    {
      resolve: `gatsby-plugin-google-fonts`,
      options: {
        fonts: [`Josefin Sans\:400,700`, `open sans\:400,700`, `Josefin Slab`],
      },
    },
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 630,
            },
          },
          'gatsby-remark-copy-linked-files',
        ],
      },
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    `gatsby-plugin-react-helmet`,
    `gatsby-plugin-sass`,
  ],
};



// WEBPACK FOOTER //
// ./gatsby-config.js